// 全局
export default {
	data(){
		return {
			
		}
	},
	mounted(){
        this.$nextTick(function() {
            // PC非微信浏览器  隐藏滚动条
            if(this.$IsPC()){
                let el = this.$refs.scrollFixed
                if(el){
                    el.style.marginRight = '-17px'
                }
            }
        });
	},
	created(){
		
	},
}


// WEBPACK FOOTER //
// ./src/vue/mixin/mixin.js